module.exports = __webpack_public_path__ + "static/media/hdsd-otp-web.11ce40c3.jpg";